const checkOrderContainsCtgs = (ctgs: any, order: any) => {
  const ctg_ids = ctgs.map((ctg: any) => ctg.id).flat();

  const order_ctgs_ids = order.article.map((art: any) => art.article.category);

  return order_ctgs_ids.some((ctg_id: any) => ctg_ids.includes(ctg_id));
};

export default checkOrderContainsCtgs;
